import axios from 'axios';
const url = window.location.href;
const arr = url.split("/");
const result = arr[0] + "//" + arr[2];
class InpostApi {
  install(Vue) {
    Vue.prototype.$inpostApi = this;
    this._inpostApi = axios.create({
      crossDomain: true,
      headers: {
        'accept': 'application/json',
        'accept-language': 'en_US',
      },
      baseURL: result + '/wp-json/',
      timeout: 100000,
    });
  }

  contactApi() {
    return new Promise((resolve, reject) => {
      this._inpostApi.get('inpost/v1/review/order'
      ).then(function (response) {
        resolve(response.data);
      }).catch(function (error) {
        reject(error.response.data);
      });
    });
  }

  updateOrderInpost(data) {
    return new Promise((resolve, reject) => {
      this._inpostApi.post('inpost/v1/update/order', data
      ).then(function (response) {
        resolve(response.data);
      }).catch(function (error) {
        reject(error.response.data);
      });
    });
  }
}

export default InpostApi;
